import { ReactElement } from 'react';
import { useDialog } from '~/hooks';
import { IS_PERCH_ENERGY, ORGANIZATION_ENTITIES } from '~/utils/constants';
import { DialogSection } from '../dialog-section.component';
import { StyledModal as Dialog } from '../dialog.style';

interface Props {
  target: ReactElement;
}

export const UtilitySyncExplainerDialog = ({ target }: Props) => {
  const { isOpen, close, TargetComponent } = useDialog(target);
  const entityName = IS_PERCH_ENERGY ? ORGANIZATION_ENTITIES.PERCH : ORGANIZATION_ENTITIES.ARCADIA;
  return (
    <>
      {TargetComponent}
      <Dialog isOpen={isOpen} onDismiss={close} aria-label="Utility Sync Explainer">
        <Dialog.Header
          title="Why do we need to integrate with your utility account?"
          onClose={close}
        />
        <DialogSection title="Why do we need your energy usage?">
          {[
            'We need to be able to understand your energy usage to determine the size of your subscription to the community solar farm — and the solar savings you get on your power bill. Your subscription size will depend on your average energy use.',
          ]}
        </DialogSection>
        <DialogSection
          title={`Understanding why ${entityName} needs to integrate with your utility account.`}
        >
          {[
            `Your utility company will continue to deliver energy to your home without interruption, but they know you are part of a community solar program. ${entityName}'s technology works with your utility account to keep track of your solar savings and make sure it's reflected accurately on your power bill.`,
          ]}
        </DialogSection>
        <DialogSection title="How do we keep your information secure?">
          {[
            `When you integrate your utility account with ${entityName}, we encrypt your account information using AWS KMS (Amazon Web Services Key Management Services). Your data is encrypted both in transit and in storage, and any decryption of your account information would be logged and tracked to ensure security.`,
          ]}
        </DialogSection>
        <Dialog.FooterStacked primaryText="Close" onSubmit={close} />
      </Dialog>
    </>
  );
};
